module.exports = __webpack_public_path__ + "img/normal_multiplier_1.e4b192c2.png";